var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAnimationEnabled)?_c('transition',{attrs:{"name":_vm.isAnimationEnabled ? 'fade-in-up' : null}},[_c('router-view')],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }